export const OttPlanConstants = {
  FETCH_OTT_PLAN_REQUEST: "FETCH_OTT_PLAN_REQUEST",
  FETCH_OTT_PLAN_SUCCESS: "FETCH_OTT_PLAN_SUCCESS",
  FETCH_OTT_PLAN_FAILURE: "FETCH_OTT_PLAN_FAILURE",
  DOWNLOAD_OTT_PLAN_REQUEST: "DOWNLOAD_OTT_PLAN_REQUEST",
  DOWNLOAD_OTT_PLAN_SUCCESS: "DOWNLOAD_OTT_PLAN_SUCCESS",
  DOWNLOAD_OTT_PLAN_FAILURE: "DOWNLOAD_OTT_PLAN_FAILURE",
  OTT_PLAN_AUTO_SEARCH_REQUEST: "OTT_PLAN_AUTO_SEARCH_REQUEST",
  OTT_PLAN_AUTO_SEARCH_SUCCESS: "OTT_PLAN_AUTO_SEARCH_SUCCESS",
  OTT_PLAN_AUTO_SEARCH_FAILURE: "OTT_PLAN_AUTO_SEARCH_FAILURE",
  GET_OTT_PLAN_REQUEST: "GET_OTT_PLAN_REQUEST",
  GET_OTT_PLAN_SUCCESS: "GET_OTT_PLAN_SUCCESS",
  GET_OTT_PLAN_FAILURE: "GET_OTT_PLAN_FAILURE",
};
